module.exports = __webpack_public_path__ + "static/media/OurEye-Banner-Transparent-Dark.57e85e35.png";